import React, { useState } from 'react';
import ProductPromptArea from '../extras/ProductPromptArea';
import ProductPhoto from '../extras/ProductPhoto';

interface ProductPhotoContainerProps {
    store: any;
}

export interface PrefillData {
    modelType: Model;
    pixiiPotion: string;
    prompt: string;
    potionTitle: string | null;
}

export type Model = 'VARIETY' | 'QUALITY FAST' | 'QUALITY SLOW';

export default function ProductPhotoContainer({ store }: ProductPhotoContainerProps) {
    const [sendData, setSendData] = useState(false);
    const [imagePrompt, setImagePrompt] = useState('');
    const [activePotion, setActivePotion] = useState<null | string>();
    const [modelType, setModelType] = useState<Model>('QUALITY FAST');

    const handleSendData = () => {
        setSendData(true);
    };

    const handleBrandFavouritesOrReuseSelect = (data: PrefillData, resuse?: boolean) => {
        const { modelType, pixiiPotion, prompt, potionTitle } = data;
        setImagePrompt(changePromptToPromptSelection(prompt));
        setModelType(modelType);
        setActivePotion(pixiiPotion);
    };
    function changePromptToPromptSelection(str: string) {
        const potionRegx = /~[\w-]+/g;
        const potionTitles = str.match(potionRegx);
        let processedPotionTitle = str; // return same if no pixii potion
        if (potionTitles) {
            processedPotionTitle = processedPotionTitle.replace(
                /~[\w-]+/,
                `@[${potionTitles[0]}](0)`,
            );
        }

        return processedPotionTitle;
    }

    return (
        <div className="generate">
            <div className="userPrompt" style={{ paddingTop: '0px' }}>
                <ProductPromptArea
                    imagePrompt={imagePrompt}
                    setImagePrompt={setImagePrompt}
                    handleSendData={handleSendData}
                />
                <ProductPhoto
                    store={store}
                    sendData={sendData}
                    setSendData={setSendData}
                    handleBrandFavouritesOrReuseSelect={handleBrandFavouritesOrReuseSelect}
                />
            </div>
        </div>
    );
}
